"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plus = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var theme_get_1 = require("@styled-system/theme-get");
var Box_1 = require("../Box");
exports.Plus = (0, styled_components_1.default)(Box_1.Box)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n\n  &::before,\n  &::after {\n    content: \"\";\n    display: block;\n    width: 100%;\n    height: ", ";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    background-color: currentColor;\n    transition: background-color 250ms;\n  }\n\n  &::before {\n    transform: translate(-50%, -50%);\n    ", "\n  }\n\n  &::after {\n    transform: translate(-50%, -50%) rotate(90deg);\n    ", "\n  }\n"], ["\n  ", "\n\n  &::before,\n  &::after {\n    content: \"\";\n    display: block;\n    width: 100%;\n    height: ", ";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    background-color: currentColor;\n    transition: background-color 250ms;\n  }\n\n  &::before {\n    transform: translate(-50%, -50%);\n    ", "\n  }\n\n  &::after {\n    transform: translate(-50%, -50%) rotate(90deg);\n    ", "\n  }\n"])), function (_a) {
    var size = _a.size;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), (0, theme_get_1.themeGet)("space.".concat(size), size), (0, theme_get_1.themeGet)("space.".concat(size), size));
}, function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? "2px" : _b;
    return strokeWidth;
}, function (_a) {
    var axis = _a.axis;
    return axis === "vertical" && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        display: none;\n      "], ["\n        display: none;\n      "])));
}, function (_a) {
    var axis = _a.axis;
    return axis === "horizontal" && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        display: none;\n      "], ["\n        display: none;\n      "])));
});
exports.Plus.defaultProps = {
    position: "relative",
    axis: "both",
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Plus.js.map